import { FlagProps } from '@boltenergy-be/design-system'
import { ReactNode } from 'react'
import type { SelectorKey } from 'i18next'

export type BannerProps = {
  onClick: () => void
}

export enum BannerTypes {
  MIDDLE_EAST_ENERGY_CRISIS = 'middleEastEnergyCrisis',
  SIMULATION_DOWN = 'simulationDown',
  SCHEDULED_DOWNTIME = 'scheduledDowntime'
}

export type PredefinedBanner = {
  singleLine?: boolean
  noOnClick?: boolean
  className?: string
} & Pick<FlagProps, 'type' | 'size' | 'icon'> &
  (
    | {
        titleKey: SelectorKey
        descriptionKey?: SelectorKey
        text?: never
      }
    | {
        text: string | ReactNode
        titleKey?: never
        descriptionKey?: never
      }
  )
